import html from '../legacy/pt.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function PyTorch() {
  return <LegacyHtmlPage slug="pt" title="PyTorch" html={html} />;
}
